import { HttpFetcher } from '@readium/shared';
import ContentEncryptionService from '../../../lib/ContentEncryptionService.js';
import { DecryptingResource } from './DecryptingResource.js';
import { fileClient } from './readiumPatches.js';

/**
 * Custom HttpFetcher that handles content decryption.
 */
export class DecryptingHttpFetcher extends HttpFetcher {
    constructor(baseURL) {
        // HttpFetcher ctor signature: (fetchClient, baseURL).
        const client = baseURL?.startsWith('file://') ? fileClient : undefined;
        super(client, baseURL);
        this.cssCache = null; // LazyCssCache instance, set by EpubViewer during init
        // [IDPF] Populated externally with deobfuscated font blob URLs.
        this.idpfFontBlobUrls = null;
    }

    get(link) {
        const originalResource = super.get(link);

        const shouldDecrypt = ContentEncryptionService.shouldDecryptFile(link.href);

        if (shouldDecrypt) {
            return new DecryptingResource(originalResource, link.href, this.cssCache, this.idpfFontBlobUrls);
        }

        return originalResource;
    }
}
